import fetch from "isomorphic-fetch";
import z from "zod";

import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/me/organisations/users").GET();

export const UserSchema = endpoint.res.shape.users.unwrap().element;
export type GetOrganisationUsersResponse = z.infer<typeof endpoint.res>;
export type User = z.infer<typeof UserSchema>;

export async function getOrganisationUsers(
    query: typeof endpoint.types.Q = { withChildren: false },
    signal?: AbortSignal,
): Promise<GetOrganisationUsersResponse | null> {
    const call = createCall(endpoint, (r) => fetch(withAccountOrNetworkAuthHeaders(r)));

    return await call({
        query,
        signal,
    });
}
